import { render, staticRenderFns } from "./purrfq.vue?vue&type=template&id=15f153ef&scoped=true&"
import script from "./purrfq.vue?vue&type=script&lang=js&"
export * from "./purrfq.vue?vue&type=script&lang=js&"
import style0 from "./purrfq.vue?vue&type=style&index=0&id=15f153ef&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f153ef",
  null
  
)

export default component.exports